export default {"src":"/_next/static/media/whiskey-exit.15090143.svg","height":235,"width":408,"blurWidth":0,"blurHeight":0};